module.exports = __webpack_public_path__ + "img/6-3.2b0f47bb.png";